import { fromJS, List, OrderedMap } from 'immutable';

//myslim sa tym JS Array to Immutable.OrderedMap
export default function array2map(array, key) {
    return List(array).reduce(
        (result, jsItem) => result.set(String(jsItem[key || 'id']), fromJS(jsItem)),
        OrderedMap()
    );
}
